import { Typography, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import React from 'react';
import responsiveFont from '../utils/responsiveFont';

const RequestCancelled = () => {
  const theme = useTheme();
  const mdMatches = useMediaQuery((theme) => theme.breakpoints.up('md'));

  React.useEffect(() => {
    document.title = 'REQUEST CANCELLED';
  });

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '4%' }}>
        <Box
          sx={{
            backgroundColor: theme.palette.menubar.main,
            width: '91%',
            height: responsiveFont(45, mdMatches),
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              color: '#fff',
              fontSize: responsiveFont(20, mdMatches),
              marginLeft: '1%',
            }}
          >
            REQUEST CANCELLED
          </Box>
        </Box>
      </Box>
      <Box mt={4} textAlign="center">
        <Typography
          sx={{
            fontWeight: '900',
            fontSize: responsiveFont(16, mdMatches),
            color: '#000000',
          }}
        >
          Your Request Has Been Cancelled
        </Typography>
        <Typography
          sx={{
            fontSize: responsiveFont(16, mdMatches),
            color: '#000000',
            marginTop: '1%',
          }}
        >
          No changes have been submitted. You may now safely close this window.
        </Typography>
        <Typography
          sx={{
            fontSize: responsiveFont(16, mdMatches),
            color: '#000000',
            marginTop: '1%',
          }}
        >
          If you need to make changes or have questions, please log in to MY LAB or contact your
          Client Service Representative for further assistance.
        </Typography>
      </Box>
    </>
  );
};

export default RequestCancelled;
